/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Connexion\ConnexionStats\ConnexionStats.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday December 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday December 13th 2023 5:48:19 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Connexion/ConnexionStats/ConnexionStats.module.css";

type ConnexionStatsProps = {
    nbConnexion: number,
    credential: {failed: number, success: number},
    refresh: {failed: number, success: number},
}

function ConnexionStats(props:ConnexionStatsProps) {
    return (
        <div className={`${Styles.holder}`}>
            <p className="m-0">{translator.decode("dynamic.total")}: {props.nbConnexion}</p>
            <p className="m-0">{translator.decode("connexion.refresh_token")}: <span className={`${Styles.success}`}>{props.refresh.success}</span> / <span className={`${Styles.failed}`}>{props.refresh.failed}</span></p>
            <p className="m-0">{translator.decode("connexion.credentials")}: <span className={`${Styles.success}`}>{props.credential.success}</span> / <span className={`${Styles.failed}`}>{props.credential.failed}</span></p>
        </div>
    )
}

export default ConnexionStats;
